import { connect } from 'react-redux';
import OrgCertificates from './OrgCertificates';
import { getTranslation } from "../../../../reducers/common/localization";
import {
    fetchGetOrgCertificates,
    loadingCertificate,
    getOrgCertificates
} from '../../../../reducers/organization/orgCertificate';
import { showModal, MODAL_ADD_CERTIFICATE, MODAL_REMOVE_CERTIFICATE } from '../../../../reducers/common/activeModal';
import { getOrgPermissionsData } from '../../../../reducers/organization/organizations';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        fetching: loadingCertificate(state),
        certificates: getOrgCertificates(state),
        permissions: getOrgPermissionsData(state)
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onGetOrgCertificates: (data) => dispatch(fetchGetOrgCertificates(data)),
        onAddCertificate: () => dispatch(showModal({ modalKey: MODAL_ADD_CERTIFICATE })),
        onRemoveCertificate: () => dispatch(showModal({ modalKey: MODAL_REMOVE_CERTIFICATE }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgCertificates);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/certificatesManagement/orgCertificates/OrgCertificates.container.js